import * as yup from 'yup'

const schema = () =>
  yup.object().shape({
    name: yup.string().required(),
    subgroup: yup.object().required(),
  })

export default schema
